var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.49984V2.6665H16V8.49984",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 16H4.33464C3.89261 16 3.46868 15.8244 3.15612 15.5118C2.84356 15.1993 2.66797 14.7754 2.66797 14.3333V10.1667C2.66797 9.72464 2.84356 9.30072 3.15612 8.98816C3.46868 8.6756 3.89261 8.5 4.33464 8.5H17.668C18.11 8.5 18.5339 8.6756 18.8465 8.98816C19.159 9.30072 19.3346 9.72464 19.3346 10.1667V14.3333C19.3346 14.7754 19.159 15.1993 18.8465 15.5118C18.5339 15.8244 18.11 16 17.668 16H16.0013",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6665H6V19.3332H16V12.6665Z",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.330c50ec508aff045fd3d2ff920ca5d4.svg";
export { ForwardRef as ReactComponent };